import theme from '@utils/theme'
import { FC, ReactNode } from 'react'
import { StyleCircle } from './style'
interface CircleProps {
  bg?: keyof typeof theme.colors
  size?: number
  children?: ReactNode
  onClick?: () => void
  styleCircle?: string
}
const Circle: FC<CircleProps> = ({
  bg = 'inputBorder',
  size = 30,
  children,
  ...restProps
}) => {
  return (
    <StyleCircle bg={bg} size={size} {...restProps}>
      {children}
    </StyleCircle>
  )
}
export default Circle
